import { EN_TENANT_NAME } from '../../enums/tenant';
import { registerPlugin } from '../../plugins/plugin_register';
import { DefaultRegistry } from '../default_registry';
import { registerTenantConfig } from '../register';

@registerTenantConfig(EN_TENANT_NAME.丹尼克尔)
export class 丹尼克尔TenantRegistry extends DefaultRegistry {
  static async register(): Promise<void> {
    // super.register();
    const { UIConfig丹尼克尔 } = await import(
      '../../plugins/service_plugins/ui_config/ui_config_丹尼克尔'
    );
    registerPlugin(UIConfig丹尼克尔);
  }
}
